import api from "./api";
import { IPagamentoLoja } from "interfaces/loja";

/** Resposta da API GET /loja/pagamentos/gerenciar */
export interface IPagamentosGerenciarResponse {
  pagamentos: IPagamentoLoja[];
  total: number;
  currentPage: number;
  totalPages: number;
}

/**
 * API: Listar pagamentos (gerenciar) - GET /loja/pagamentos/gerenciar
 * Query: page, limit, status, metodo, pedidoId, usuario, from, to
 * Resposta: { pagamentos, total, currentPage, totalPages }
 */
export async function listarPagamentosLoja(params?: {
  page?: number;
  limit?: number;
  status?: string;
  metodo?: string;
  pedidoId?: string;
  usuario?: string;
  from?: string;
  to?: string;
}) {
  try {
    const search = new URLSearchParams();
    if (params?.page != null) search.set("page", String(params.page));
    if (params?.limit != null) search.set("limit", String(params.limit));
    if (params?.status) search.set("status", params.status);
    if (params?.metodo) search.set("metodo", params.metodo);
    if (params?.pedidoId) search.set("pedidoId", params.pedidoId);
    if (params?.usuario) search.set("usuario", params.usuario);
    if (params?.from) search.set("from", params.from);
    if (params?.to) search.set("to", params.to);
    const { data, status } = await api.get<IPagamentosGerenciarResponse>(
      `/loja/pagamentos/gerenciar${search.toString() ? `?${search}` : ""}`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error?.response?.data?.error || error.message || "Falha na comunicação");
  }
}

/**
 * API: Detalhe do pagamento (gerenciar) — GET /loja/pagamentos/gerenciar/:pagamentoId
 * Resposta: objeto do pagamento (moeda, provedor, respostaBrutaTexto, etc.).
 */
export async function detalharPagamentoGerenciarLoja(pagamentoId: string) {
  try {
    const { data, status } = await api.get<IPagamentoLoja>(
      `/loja/pagamentos/gerenciar/${encodeURIComponent(pagamentoId)}`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message ||
        "Falha ao carregar o pagamento."
    );
  }
}

/**
 * API: Atualizar status do pagamento (manual) - PUT /loja/pagamentos/:id/status
 * Body: { status, observacao?, restockNow?, motivoBaixaManual? } — motivo obrigatório no backend para BOLETO → PAGO.
 */
export async function atualizarStatusPagamentoLoja(
  pagamentoId: string,
  status: "PAGO" | "CANCELADO" | "ESTORNADO",
  body?: {
    observacao?: string;
    restockNow?: boolean;
    motivoBaixaManual?: string;
  }
) {
  try {
    const { data, status: httpStatus } = await api.put(
      `/loja/pagamentos/${pagamentoId}/status`,
      { status, ...body }
    );
    return { data, status: httpStatus };
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error?.response?.data?.error || error.message || "Falha na comunicação");
  }
}
